module.exports = __webpack_public_path__ + "static/media/file-preview-ph.475f8c8f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/images/file-preview-ph.svg
// module id = 1731
// module chunks = 0